const springServeVast =
  "https://vid.springserve.com/vast/493180?w=1920&h=1080&cb={{CACHEBUSTER}}&ip={{IP}}&ua={{USER_AGENT}}&pod_max_dur=15&pod_ad_slots=1"
const liveStreamSrc =
  "https://stream-op.sw.fubo.tv/offplatform/fsn/master.m3u8?ads.partner=fsn&ads.station_id=120123"
const liveStreamType = "application/x-mpegURL"

const imgxBaseUrl = "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/"

export { springServeVast, liveStreamSrc, liveStreamType }
